import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/calendar/useCalendarQueryKeys.ts
var t = e("occupancy", { forWorkspace: (e, t) => [
	"workspace",
	e,
	t
] }), n = e("occupancy", {
	all: () => ["availabilityGrid"],
	forProperty: (e, t, n) => [
		"availabilityGrid",
		e,
		t,
		n
	]
});
//#endregion
export { n as availabilityGridQueryKeys, t as occupancyQueryKeys };
